
const filePreviewStyle = theme => ({
	webviewer: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 90)
	}


	// webviewer: {
	// 	height: "100vh"
	// }
})

export {filePreviewStyle}